import browser from '@openclassrooms/utils/browser';
import store from 'Modules/store';
import AppProviders from 'Modules/webapp/components/AppProviders';
import Webapp from 'Modules/webapp/components/Webapp';

function initWebApp() {
  const container = browser.document.getElementById('webapp');

  if (!container) {
    return;
  }

  store.renderElementWrappedWithProvider(
    <AppProviders productionPrefix="webapp">
      <Webapp />
    </AppProviders>,
    container
  );
}

export default initWebApp;
